import { useFormContext, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import ToggleInput from "./FormInputs/ToggleInput";

FormToggleField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
}

export default function FormToggleField({ fieldName, fieldAttributes }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={() => (
        <ToggleInput
          fieldAttributes={fieldAttributes}
          fieldName={fieldName}
        />
      )}
    />
  );
}